export const en = {
    'add-creatives': 'Add selected creatives',
    apply: 'Use',
    'cancel-and-return': 'Cancel',
    create: 'Use as template',
    edit: 'Edit',
    'export-excel': 'Export list as XLS',
    select: 'Select',
    selected: '{selected} of {total} selected'
};
